export type NewEmailError = 'invalid' | 'unchanged'

// Rough check only, the backend validates the address again.
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function validateNewEmail(newEmail: string, currentEmail?: string | null): NewEmailError | null {
  const trimmed = newEmail.trim()
  if (!EMAIL_PATTERN.test(trimmed)) return 'invalid'
  if (currentEmail && trimmed.toLowerCase() === currentEmail.trim().toLowerCase()) return 'unchanged'
  return null
}
